import { apiService } from './api';
import { PaginationParams } from '../types';

export interface RentalBookingDTO {
  id: number;
  bookingNumber: string;
  customerId: number;
  customerName?: string;
  vehicleId: number;
  vehicleLabel?: string;
  pickupDate: string;
  returnDate: string;
  pickupLocation?: string;
  returnLocation?: string;
  totalAmount: number;
  deposit: number;
  status: 'Draft' | 'PendingPayment' | 'Confirmed' | 'Active' | 'Completed' | 'Cancelled' | 'NoShow';
  notes?: string;
  createdAt: string;
}

export interface CreateRentalBookingRequest {
  customerId: number;
  vehicleId: number;
  pickupDate: string;
  returnDate: string;
  pickupLocation?: string;
  returnLocation?: string;
  notes?: string;
}

const API = '/car-rental/bookings';

export const rentalBookingService = {
  getAll: (params: PaginationParams = {}) =>
    apiService.get<RentalBookingDTO[]>(API, { pageNumber: params.pageNumber || 1, pageSize: params.pageSize || 200 }),

  getById: (id: number) => apiService.get<RentalBookingDTO>(`${API}/${id}`),

  create: (data: CreateRentalBookingRequest) => apiService.post<RentalBookingDTO>(API, data),

  cancel: (id: number) => apiService.post<RentalBookingDTO>(`${API}/${id}/cancel`, {}),

  confirm: (id: number) => apiService.post<RentalBookingDTO>(`${API}/${id}/confirm`, {}),
};
